import { type GQLError } from '@egw/clients'
import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query'
import { type WealthOverview } from '../../models'
import { getWealthOverview } from '../../services/product'

/**
 * Customer Details state hook
 * @param options - tanstack useQuery options
 * @returns tanstack useQuery result, data is of type CustomerDetails
 */
export const useWealthOverview = (
  options?: Omit<UseQueryOptions<WealthOverview, GQLError>, 'queryKey' | 'queryFn' | 'select'>,
): UseQueryResult<WealthOverview, GQLError> =>
  useQuery<WealthOverview, GQLError>({
    queryKey: ['wealthOverview'],
    queryFn: getWealthOverview,
    ...options,
  })
